import React, { useEffect, useRef, useState } from "react";

export default function PnlHistoryRowMenu({ row, canModify, cancelling, onEdit, onCancel }) {
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onDocClick = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    const onEsc = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    window.addEventListener("mousedown", onDocClick);
    window.addEventListener("keydown", onEsc);
    return () => {
      window.removeEventListener("mousedown", onDocClick);
      window.removeEventListener("keydown", onEsc);
    };
  }, [open]);

  if (!canModify) {
    return <span className="muted">—</span>;
  }

  return (
    <div className="table-row-menu" ref={menuRef}>
      <button
        type="button"
        className="table-row-menu-trigger btn-secondary compact-btn"
        onClick={() => setOpen((v) => !v)}
        aria-haspopup="menu"
        aria-expanded={open}
        aria-label="P&L row actions"
      >
        Actions
        <span aria-hidden="true">▾</span>
      </button>
      {open ? (
        <div className="table-row-menu-dropdown card" role="menu">
          <button
            type="button"
            className="table-row-menu-item"
            role="menuitem"
            onClick={() => {
              setOpen(false);
              onEdit(row);
            }}
          >
            Edit submission
          </button>
          <button
            type="button"
            className="table-row-menu-item table-row-menu-item--danger"
            role="menuitem"
            disabled={cancelling}
            onClick={() => {
              setOpen(false);
              onCancel(row);
            }}
          >
            {cancelling ? "Cancelling…" : "Cancel submission"}
          </button>
        </div>
      ) : null}
    </div>
  );
}


